import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Row, Col, Accordion, Card } from 'react-bootstrap';
import snakeCaseKeys from 'snakecase-keys';
import { LinkBtn, SimpleCenteredModal, ImportModal } from '../../components';
import {
  debounceIndexDncRequest,
  preImportDncRequest,
  importTemplateDncRequest,
  importDncRequest
} from '../../requests/dncs';
import DncDatatable from './DncDatatable';
import DncFilter from './DncFilter';
import columnDnc from './columnDnc';
import './style.scss';

const DncIndex = () => {
  const [dncs, setDncs] = useState([]);
  const [amount, setAmount] = useState(0);
  const [moreData, setMoreData] = useState(false);
  const [onRequest, setOnRequest] = useState(false);
  const [customParams, setCustomParams] = useState({});
  const [simpleModalShow, setSimpleModalShow] = useState(false);
  const [activeAccordion, setActiveAccordion] = useState('0');
  const [hasSearched, setHasSearched] = useState(false);
  const dispatch = useDispatch();

  const handleIndexRequest = params => {
    if (!hasSearched) return;
    setOnRequest(true);
    const sendParams = {
      ...params,
      ...customParams
    };
    const request = async () =>
      debounceIndexDncRequest({
        dispatch,
        params: sendParams,
        successCallback: response => {
          const data = response?.data?.data || [];
          const metadata = response?.data?.metadata || { amount: 0 };
          setDncs(data);
          setAmount(metadata.amount);
        },
        callback: () => setOnRequest(false)
      });
    request();
  };

  const handleFilterAdvance = values => {
    const cleanedValues = Object.entries(values).reduce((acc, [key, value]) => {
      if (value !== '' && value !== null && (Array.isArray(value) ? value.length > 0 : true)) {
        acc[key] = value;
      }
      return acc;
    }, {});
    setCustomParams(snakeCaseKeys(cleanedValues));
    setHasSearched(true);
    setMoreData(prev => !prev);
  };

  const handleMassAction = action => {
    switch (action) {
      case 'import':
        setSimpleModalShow(true);
        break;
      default:
        // eslint-disable-next-line no-console
        console.log('Error: Action not found');
    }
  };

  return (
    <>
      <Row className="mt-4 mb-4">
        <Col>
          <h2 className="mt-3">Detección de Necesidades de Capacitación (DNC)</h2>
        </Col>
        <Col md={3} className="px-md-0 pr-xl-2 my-3 mr-md-2 d-flex justify-content-end align-items-center">
          <LinkBtn variant="primary" className="mb-0" to="/dnc/new">
            Nuevo
          </LinkBtn>
        </Col>
      </Row>

      <Accordion activeKey={activeAccordion} onSelect={key => setActiveAccordion(key)}>
        <Card className="mb-3">
          <Col className="top-header-employee py-2">
            <Accordion.Toggle
              as={Col}
              eventKey="0"
              className="card-header-title d-flex justify-content-between align-items-center"
              onClick={() => setActiveAccordion(activeAccordion === '0' ? null : '0')}
              style={{ textAlign: 'right', cursor: 'pointer' }}
            >
              <span>FILTROS DE BÚSQUEDA</span>
              <span className="h4 mr-2">{activeAccordion === '0' ? '−' : '+'}</span>
            </Accordion.Toggle>
          </Col>
          <Accordion.Collapse eventKey="0">
            <Card.Body className="employee-filters">
              <DncFilter formRequest={handleFilterAdvance} />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>

      <div className="data-table-yellow">
        <DncDatatable
          dncs={dncs}
          amount={amount}
          onRequest={onRequest}
          handleIndexRequest={handleIndexRequest}
          customParams={customParams}
          moreData={moreData}
          setMoreData={setMoreData}
          columnDnc={columnDnc}
          handleMassAction={handleMassAction}
        />
      </div>

      <SimpleCenteredModal
        title="Importar DNC"
        body={
          <ImportModal
            onDropUploaded={preImportDncRequest}
            handleTemplate={importTemplateDncRequest}
            hideModal={() => setSimpleModalShow(false)}
            onHide={importDncRequest}
            updateData={() => setMoreData(!moreData)}
          />
        }
        show={simpleModalShow}
        onHide={() => setSimpleModalShow(false)}
      />
    </>
  );
};

export default DncIndex;
